// elements/theming/input-token.ts
import "../../chemistry-lit-element";
import "lit/directives/style-map.js";
import "../../chemistry-lite-element";
var inputToken = (host) => ({
  fontFamily: `${host.fontFamily}, sans-serif`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  paddingTop: host.spacing.sm,
  paddingLeft: host.spacing.md,
  paddingRight: host.spacing.md,
  paddingBottom: host.spacing.sm,
  border: `2px solid ${host.colors.neutral_200}`,
  borderRadius: host.sizes.borderRadius,
  background: host.colors.neutral_100,
  fontSize: host.baseFontSize + "px"
});
export {
  inputToken
};
